export default "__VITE_ASSET__BwSxh0CD__"